module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAeCAYAAAAo5+5WAAAAAXNSR0IArs4c6QAAAQxJREFUSEvtls9qwkAQh79R603Qh/HWBPRc+gARxCdo6UUoPYvgRfQJimAeQLzaQtJbH6al3qx1ZOOfxhpaU8jJndNm2fkYfruT3wi7aIRXqN4hVIHSfv+0xRzlFZE+Y2dqUiTK84IOIvegm+9/hyiqXXz3QTCVwgRdLSDXprgc8Vh7T8VuPZdZFJqw6iG5InAteMEMoY7KLb4zTAX8edgLbxAdoDwJjeAj0vTiq5JYqReECJcHDOUF33WOijCVf+bfgLkBa3Rg7CbrmwZsOFve3+C02ljwd6Nt7sxqbJ9brItsg9gGOf6pnsGrMBZlIsnr4oLEpPjdTHdJp4APzDQ7+89qYMlsxMpoKFwDZF/Y8+Ir+ckAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rppghealth/rppgphone.png
// module id = a0YO
// module chunks = 5